import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CopyContext = createContext(null);

/**
 * Archetype copy. Pages never hardcode wording — they ask for a key and get the
 * language that fits the person in front of them.
 *   const { c, nav } = useCopy();
 *   c('discover.title', 'Discover Me')
 */
export const CopyProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [pack, setPack] = useState(null);

  useEffect(() => {
    if (!user || !token) { setPack(null); return; }
    axios.get(`${API}/copy-pack`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setPack(r.data))
      .catch(() => setPack(null));
  }, [user, token]);

  const value = useMemo(() => {
    const c = (path, fallback = '') => {
      if (!pack) return fallback;
      const found = path.split('.').reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), pack);
      return found || fallback;
    };
    return {
      pack,
      c,
      nav: pack?.nav || {},
      vocab: pack?.vocab || {},
      audience: pack?.audience || 'adult',
      isStudentCopy: (pack?.audience || 'adult') === 'student',
    };
  }, [pack]);

  return <CopyContext.Provider value={value}>{children}</CopyContext.Provider>;
};

export const useCopy = () => useContext(CopyContext) || {
  pack: null, c: (_p, f = '') => f, nav: {}, vocab: {}, audience: 'adult', isStudentCopy: false,
};
